import type { Capabilities } from '@rtkwlf/rendall';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useOrganizationContext } from '@packages/legacy/organization-context';
import { useFeatureFlag } from '@packages/platform/feature-flags/use-feature-flag';
import { TWENTY_FOUR_H_IN_MS } from 'ae-constants/constants';

import { useRendallApi } from '../use-rendall-api';

export const getLegacyCapabilitiesKey = (organizationId: string) => [
  organizationId,
  'rendall',
  'get-capabilities',
];

export const useLegacyCapabilitiesOptions = (
  options?: UseQueryOptions<Capabilities, unknown>,
) => {
  const api = useRendallApi();
  const { selectedOrganization } = useOrganizationContext();
  const [eventsSource] = useFeatureFlag('EVENT_LOG_EVENTS_SOURCE');
  const organizationId = selectedOrganization.id;

  return {
    enabled: Boolean(organizationId), // TODO AWN-217933
    gcTime: TWENTY_FOUR_H_IN_MS,
    queryFn: () =>
      api.getCapabilities(
        { organizationId },
        {
          headers: eventsSource ? { 'X-Instance': 'ch_events' } : {},
        },
      ),
    queryKey: getLegacyCapabilitiesKey(organizationId),
    ...options,
  };
};

export const useLegacyCapabilities = (
  options?: UseQueryOptions<Capabilities, unknown>,
) => {
  return useQuery(useLegacyCapabilitiesOptions(options));
};
